<template>
    <Layout is-crm>
        <Spinner v-if="loading" />
        <div>USERS</div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

export default {
    name: 'UsersPage',
    components: {
        Layout,
        Spinner,
    },
    data() {
        return {
            loading: false,
            error: null,
        };
    },
};
</script>

<style lang="scss" src="./UsersPage.scss"></style>
